<template>
	<div class="plane-collection-list" :class="{'isiOSX':isiOSX}">
		<van-nav-bar
		  title="收藏航班"
		  left-arrow
		  @click-left="reBack"
		/>
		<span v-if="hasCollection" class="editor" @click="onClickRight">{{editorText}}</span>
		<div class="collection-list">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="hasCollection">
				<van-list
					class="allList"
					:class="{'editorList':editorStatus}"
				  v-model="loading"
				  :finished="finished"
				  finished-text="没有更多了"
				  @load="onLoad"
				>
				  <van-cell v-for="(item, index) in list" :key="index">
				  	<div class="delect" v-if="delect" @click="delectFlight(item.id)">删除</div>
				  	<div class="oilList"  :style="liststyle" @click="search(item)">
				  		<p class="company">
				  			<img :src="item.air_comImage_url"/>
				  			<span class="name">{{item.company_name}}{{item.flight_no}}</span> {{item.airplane_name}}
				  			<span v-if="item.plane_model">(<span v-if="item.plane_model == 1">大</span><span v-if="item.plane_model == 2">中</span><span v-if="item.plane_model == 3">小</span><span v-if="item.plane_model == 0">其他</span>)</span>
	            			<span v-else>(其他)</span>
				  			<!--<span class="right">￥<span class="money">1900</span><span class="reback">返</span></span>-->
				  		</p>
				  		<div class="airline">
				  			<p>
					  			<span class="edge">
					  				<span class="city">{{item.depart_city}}</span>
					  				<span class="time">{{item.departure_time}}</span>
					  				<span class="airport">{{item.depart_airport_name}}</span>
					  			</span>
					  			<span class="middle">
					  				<span>{{item.flight_time}}</span>
					  				<img v-if="item.stop_num == 0" src="../../assets/plane/aircraft.png" />
	                  				<img v-if="item.stop_num != 0 && !item.flight_no1" src="../../assets/plane/stop.png" />
	                  				<img v-if="item.stop_num != 0 && item.flight_no1" src="../../assets/plane/stop_long.png" />
					  			</span>
					  			<span class="edge">
					  				<span class="city">{{item.arrive_city}}</span>
					  				<span class="time">{{item.arrive_time}}</span>
					  				<span class="airport">{{item.arrive_airport_name}}</span>
					  			</span>
				  			</p>
				  		</div>
				  	</div>
				  </van-cell>
				</van-list>
			</van-pull-refresh>
			<van-row class="empty" v-if="!hasCollection">
				<van-col class="emptyMsg" span="24">
					<img src="../../assets/plane/nocollect.png"/>
					<p class="tip1">暂无收藏航班</p>
					<p class="btn"><span @click="reBack">去收藏</span></p>
				</van-col>
			</van-row>
		</div>
		
	</div>
</template>

<script>
export default {
  data() {
    return {
    	list: [],
	  	loading: false,
  		finished: false,
  		isLoading: false,
    	page: 1,
    	pageSize: 10,
    	allList: 11, //默认比第一页数据多1
		editorStatus: false,
		editorText: '编辑',
		liststyle:{
	      width: (document.body.clientWidth - 40) + 'px'
		},
		delect: false,
		hasCollection: false,
		isiOSX: false,
		flightTime: ''
    	
    };
  },
  created(){
　　this.getInfo();
  	this.isiOSX = this.isIphoneX();
  	this.flightTime = this.$route.query.departure_date;
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
      	this.page ++;
      	this.getInfo();
	      	
        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
    	this.page = 1;
		this.finished = false;
    	this.list = [];
	    this.getInfo();
//    setTimeout(() => {
//      this.$toast('刷新成功');
//      this.isLoading = false;
//    }, 500);
    },
    getInfo() {
    	this.$api.post("/air/member/booking/collection/list",{page: this.page}).then(res => {
			this.allList = res.total;
			this.hasCollection = !!res.total;
	        if(res.list.length > 0) {
	        	for(let i in res.list) {
	        		var flight_time = res.list[i].flight_time;
	        		if(flight_time != null){
		        		var len = flight_time.length;
		        		if(flight_time.substr(0,1) == 0){
		        			res.list[i].flight_time = flight_time.substr(1,len-4)+'小时'+flight_time.substr(len-2,2)+'分钟'
		        		}else {
		        			res.list[i].flight_time = flight_time.substr(0,len-3)+'小时'+flight_time.substr(len-2,2)+'分钟'
		        		}
		        	}
		        	this.list.push(res.list[i]);
		        }
	        }
	        this.loading = false;
	        if (this.list.length >= this.allList) {// 数据全部加载完成
	          this.finished = true;
	        }
	        if(this.isLoading) {
	        	this.$toast('刷新成功');
        		this.isLoading = false;
	        }
	        
	    }).catch(err => {
	        let keys = Object.keys(err);
		     	let key = keys[0];
		  		let message = err.message || err[key][0]
			    //this.$toast(message);
			    if(message.slice(0, 10) == 'timeout of') {
		  			this.$toast('网络不给力，请稍候重试');
		  		}else {
		  			this.$toast(message);
		  		}
        	return;
        });
    },
    // 搜索
    search(item) {
    	if(this.editorStatus) {
    		return;
    	}
    	if(item.departure_date) {
    		let diff = new Date(item.departure_date).getTime() - new Date(this.$route.query.departure_date).getTime();
    		if(diff > 0) {
	    		this.flightTime = item.departure_date;
	    	}
    	}
        this.$router.push({
          path: "/select/list",
          query: {
            departure: item.depart_city_code,
            destination: item.arrive_city_code,
            child_quantity: 0,
            baby_quantity: 0,
            departure_date: this.flightTime,//默认选择明天日期
            cabin: 0,
          	selected: '',
          	departure_city: item.depart_city,
          	arrive_city: item.arrive_city
          }
        });
     
    },
    delectFlight(par) {
    	this.$api
        .post("/air/member/booking/cancel/collection", {id:par})
        .then(res => {
          	for(let i in this.list) {
          		if(this.list[i].id == par) {
          			this.list.splice(i,1);
						this.hasCollection = !!this.list.length;
          		}
          	}
        })
        .catch(err => {
	        let keys = Object.keys(err);
		     	let key = keys[0];
		  		let message = err.message || err[key][0]
			    //this.$toast(message);
			    if(message.slice(0, 10) == 'timeout of') {
		  			this.$toast('网络不给力，请稍候重试');
		  		}else {
		  			this.$toast(message);
		  		}
      	});
    },
    reBack() {
    	this.$router.go(-1);
    },
    onClickRight() {
    	if(this.editorStatus == false) {
    		this.editorText = '完成';
    	}else {
    		this.editorText = '编辑';
    	}
    	this.delect = !this.delect;
    	this.editorStatus = !this.editorStatus;
    }
  }
};
</script>

<style lang="less">
.plane {
	&-collection-list {
		background: #f2f2f2;
		height: 100%;
		.editor {
			position: fixed;
			top: 20px;
			right: 0;
			width: 50px;
			height: 46px;
			line-height: 46px;
			z-index: 2;
			font-size: 14px;
			text-align: center;
		}
		.van-nav-bar {
  		background: #F2F2F2;
  		padding-top: 24px;
  		position: fixed;
  		top: 0;
  		left: 0;
  		width: 100%;
  		.van-nav-bar__title {
  			font-size: 18px;
  			color: #333;
  		}
  		.van-icon-arrow-left:before {
  			display: none;
  		}
  		.van-nav-bar__left {
  			left: 11px;
  			.van-icon {
  				width: 17px;
  				height: 15px;
  				display: inline-block;
  				background: url(../../assets/plane/reBack.png) no-repeat center center;
  				background-size: 100% 100%;
  			}
  		}
  	}
  	.van-hairline--bottom::after {
  		border: none;
  	}
  	.collection-list{
  		height: 100%;
	    overflow-y: scroll;
	    -webkit-overflow-scrolling:touch;
	  	.van-pull-refresh {
	  		padding-top: 74px;
				.allList{
					padding: 4px 11px 0;
					background: #f2f2f2;
					.van-cell {
						background: #fff;
						border-radius: 10px;
						margin-bottom: 7px;
						box-shadow: #E3E3E3 2px 0 4px;
						padding: 0 0 0 10px;
						position: relative;
						.delect {
							width: 63px;
							height: 127px;
							line-height: 127px;
							color: #fff;
							font-size: 14px;
							text-align: center;
							background: #ff6059;
							position: absolute;
							top: 0;
							right: 0;
							border-top-right-radius: 10px;
							border-bottom-right-radius: 10px;
						}
						.oilList {
							.company {
								color: #666;
								font-size: 13px;
								height: 31px;
								line-height: 36px;
								overflow: hidden;
								border-bottom: solid 1px #f2f2f2;
								img {
									width: 14px;
									float: left;
									margin-top: 9px;
								}
								.name {
									padding: 0 15px 0 7px;
								}
								.right {
									float: right;
									text-align: center;
									color: #E6212F;
									font-size: 14px;
									.money {
										font-size: 21px;
										margin-right: 7px;
									}
									.reback {
										color: #333;
										font-size: 11px;
										padding: 2px;
										background: #FFC663;
										border-radius: 3px;
										margin-right: 2px;
									}
								}
							}
							.airline {
								text-align: center;
								span {
									display: inline;
									text-align: center;
									color: #666;
									font-size: 13px;
								}
								.edge {
									text-align: center;
									display: inline-block;
									span {
										display: inline-block;
									}
									.city {
										color: #333;
										font-size: 17px;
										height: 34px;
										line-height: 34px;
										margin-top: 5px;
										display: block;
									}
									.time {
										height: 18px;
										line-height: 18px;
										display: block;
									}
									.airport {
										height: 19px;
										line-height: 19px;
										margin-bottom: 19px;
										display: block;
									}
									.line {
										height: 0;
									}
								}
								.middle {
									width: 97px;
									padding: 0 28px;
									display: inline-block;
									vertical-align: bottom;
									padding-bottom: 23px;
									span {
										width: 97px;
										height: 18px;
										line-height: 19px;
										border-radius: 9px;
										color: #fff;
										font-size: 13px;
										background: #FEAB7A;
										text-align: center;
										display: inline-block;
										margin-bottom: 16px;
									}
									img {
										width: 97px;
										display: block;
									}
								}
								@media screen and (max-width: 320px) {
							        .middle {
						            padding: 0 14px 17px 14px;
						          }
							    }
							}
						}
					}
				}
			}
		}
		.empty {
			padding-top: 202px;
			.emptyMsg {
				padding: 0 68px;
				text-align: center;
				img {
					width: 100%;
					display: block;
				}
				.tip1 {
					color: #999;
					font-size: 14px;
					margin: 42px 0;
					height: 26px;
					line-height: 26px;
				}
				.btn {
					text-align: center;
					span {
						width: 110px;
						height: 32px;
						line-height: 32px;
						color: #FF6059;
						display: inline-block;
						border: solid 1px rgba(255,96,89,0.4);
						border-radius: 16px;
						box-shadow: rgba(255,96,89,0.1) 3px 0 6px;
					}
				}
			}
		}
		.editorList {
			margin-left: -65px;
		}
	}
}
.isiOSX {
	.van-nav-bar{
		padding-top: 44px;
	}
	.van-pull-refresh {
		padding-top: 136px;
	}
}
</style>
